export default __webpack_public_path__ + "static/image17-d15be3bc511ee7ef39949931d5679897.gif";